import { Grid2 as Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import DrilldownItem from '@components/DrilldownItem';
import { FormikToggleField } from '@components/FormikFields';

import { useCuration } from '@hooks/useCuration';

import type { FormValues } from './Card';

const messages = defineMessages({
  smoker: {
    id: 'clientProfileCard.smoker',
    defaultMessage: 'Smoker',
  },
  diabetic: {
    id: 'clientProfileCard.diabetic',
    defaultMessage: 'Diabetic',
  },
  hypertension: {
    id: 'clientProfileCard.hypertensive',
    defaultMessage: 'Hypertension',
  },
  bpMeds: {
    id: 'clientProfileCard.bpMedication',
    defaultMessage: 'Blood Pressure Medication',
  },
  yes: {
    id: 'GLOBAL.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'GLOBAL.no',
    defaultMessage: 'No',
  },
  unknown: {
    id: 'GLOBAL.unknown',
    defaultMessage: 'Unknown',
  },
  save: {
    id: 'GLOBAL.save',
    defaultMessage: 'Save',
  },
});

interface ScanProfileFormProps {
  patient_age?: number | null;
}

export default function ScanProfileForm({ patient_age }: ScanProfileFormProps) {
  const { formatMessage } = useIntl();
  const { setFieldValue, values } = useFormikContext<FormValues>();
  const {
    state: { isEditing },
  } = useCuration();

  const displayDemographic = (value: boolean | null) =>
    formatMessage(
      typeof value === 'boolean'
        ? value
          ? messages.yes
          : messages.no
        : messages.unknown
    );

  return (
    <>
      {patient_age && patient_age >= 18 && (
        <>
          <Grid size={{ xs: 3 }}>
            {isEditing ? (
              <FormikToggleField
                headerLabel={formatMessage(messages.smoker)}
                label={formatMessage(
                  values.isSmoker ? messages.yes : messages.no
                )}
                name="isSmoker"
                onChange={(value) => {
                  setFieldValue('isSmoker', value);
                }}
              />
            ) : (
              <DrilldownItem
                label={formatMessage(messages.smoker)}
                name="isSmoker"
                readOnly
                value={displayDemographic(values.isSmoker)}
              />
            )}
          </Grid>
          <Grid size={{ xs: 3 }}>
            {isEditing ? (
              <FormikToggleField
                headerLabel={formatMessage(messages.diabetic)}
                label={formatMessage(
                  values.isDiabetic ? messages.yes : messages.no
                )}
                name="isDiabetic"
                onChange={(value) => {
                  setFieldValue('isDiabetic', value);
                }}
              />
            ) : (
              <DrilldownItem
                label={formatMessage(messages.diabetic)}
                name="isDiabetic"
                readOnly
                value={displayDemographic(values.isDiabetic)}
              />
            )}
          </Grid>
          <Grid size={{ xs: 3 }}>
            {isEditing ? (
              <FormikToggleField
                headerLabel={formatMessage(messages.hypertension)}
                label={formatMessage(
                  values.isHypertensive ? messages.yes : messages.no
                )}
                name="isHypertensive"
                onChange={(value) => {
                  setFieldValue('isHypertensive', value);
                }}
              />
            ) : (
              <DrilldownItem
                label={formatMessage(messages.hypertension)}
                name="isHypertensive"
                readOnly
                value={displayDemographic(values.isHypertensive)}
              />
            )}
          </Grid>
          <Grid size={{ xs: 3 }}>
            {isEditing ? (
              <FormikToggleField
                headerLabel={formatMessage(messages.bpMeds)}
                label={formatMessage(
                  values.useBpMeds ? messages.yes : messages.no
                )}
                name="useBpMeds"
                onChange={(value) => {
                  setFieldValue('useBpMeds', value);
                }}
              />
            ) : (
              <DrilldownItem
                label={formatMessage(messages.bpMeds)}
                name="useBpMeds"
                readOnly
                value={displayDemographic(values.useBpMeds)}
              />
            )}
          </Grid>
        </>
      )}
    </>
  );
}
